"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M16 21c-.55 0-1-.45-1-1v-5.09c0-.98.71-1.8 1.67-1.97C18.56 12.63 20 10.98 20 9c0-2.21-1.79-4-4-4-1.98 0-3.63 1.44-3.94 3.33-.17.96-.99 1.67-1.97 1.67H5.83l.88.88c.39.39.39 1.02 0 1.41-.39.39-1.02.39-1.41 0L2.71 9.71a.9959.9959 0 0 1 0-1.41L5.3 5.71c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L5.83 8h4.25c.48-2.84 2.94-5 5.92-5 3.31 0 6 2.69 6 6 0 2.97-2.16 5.44-5 5.92V20c0 .55-.45 1-1 1z"
}), 'RoundaboutLeftRounded');